import {Activity} from '../Activity'
import {CollapsiblePanel} from '../CollapsiblePanel'
import {ActivitySelector} from './ActivitySelector'
import {useEffectiveSelection} from '../data/use-effective-selection'

export function ActivitySection() {
  const {effectiveSelection} = useEffectiveSelection()

  if (!effectiveSelection) return null

  return (
    <CollapsiblePanel heading="Activity summary" headerAction={<ActivitySelector />}>
      <Activity />
    </CollapsiblePanel>
  )
}
